import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Form from "../../common/Form";
import Row from "../../common/Row";
import SelectInput from "../../common/SelectInput";
import TextInput from "../../common/TextInput";
import NumberInput from "../../common/NumberInput";
import RadioButtonGroup from '../../common/RadioButtonGroup';

const InvesteringEditForm = (props) => {
    const {
        model,
        color,
        disabled,
        onBewaarClick,
        onSluitClick,
        onChange,
        validationMessages,
        investeringTypes,
        hoofdCategorieen,
        btwPercentages,
        aftrekbaar,
        validationMessageType
    } = props;

    const infrastructuren = model.infrastructuren ? model.infrastructuren.map(infrastructuur => { return { label: infrastructuur.naam, value: infrastructuur.id }; }) : [];

    return (<Section title={"Vul onderstaande gegevens in"} color={color}>
        <Form
            title={"Invulformulier investeringen voor een infrastructuur"}
            name="invulformulierInvestering"
            rightButtonLabel="Bewaar"
            onRightButtonClick={onBewaarClick}
            leftButtonLabel="Sluit"
            onLeftButtonClick={onSluitClick}
            isNotRequired
            longTitle
        >
            <Row>
                <SelectInput
                    name="infrastructuurId"
                    label={"Infrastructuur"}
                    items={infrastructuren}
                    value={model.infrastructuurId}
                    size={6}
                    onChange={onChange}
                    validationMessage={validationMessages.infrastructuurId}
                    validationMessageType={validationMessageType}
                    disabled={disabled}
                />
                <SelectInput
                    name="type"
                    label={"Aard"}
                    items={investeringTypes}
                    value={model.type}
                    size={6}
                    onChange={onChange}
                    validationMessage={validationMessages.type}
                    validationMessageType={validationMessageType}
                    disabled={disabled}
                />
            </Row>
            <Row>
                <SelectInput
                    name="hoofdcategorie"
                    label={"Hoofdcategorie"}
                    items={hoofdCategorieen}
                    value={model.hoofdcategorie}
                    size={6}
                    onChange={onChange}
                    validationMessage={validationMessages.hoofdcategorie}
                    validationMessageType={validationMessageType}
                    disabled={disabled}
                />
                <TextInput
                    name="omschrijvingStelpost"
                    label={"Omschrijving"}
                    value={model.omschrijvingStelpost}
                    size={6}
                    maxLength={100}
                    onChange={onChange}
                    validationMessage={validationMessages.omschrijvingStelpost}
                    validationMessageType={validationMessageType}
                    disabled={disabled}
                />
            </Row>
            <Row>
                <NumberInput
                    name="bedragExclusiefBTW"
                    label={"Bedrag excl. BTW"}
                    labelInside
                    value={model.bedragExclusiefBTW}
                    isValuta
                    size={3}
                    onChange={onChange}
                    validationMessage={validationMessages.bedragExclusiefBTW}
                    validationMessageType={validationMessageType}
                    disabled={disabled}
                />
                <RadioButtonGroup
                    name="btwPercentage"
                    label={"BTW percentage"}
                    labelInside
                    items={btwPercentages}
                    value={model.btwPercentage}
                    size={3}
                    onChange={onChange}
                    validationMessage={validationMessages.btwPercentage}
                    validationMessageType={validationMessageType}
                    disabled={disabled}
                    horizontal
                />
                <RadioButtonGroup
                    name="btwAftrekbaar"
                    label={"BTW aftrekbaar"}
                    labelInside
                    items={aftrekbaar}
                    value={model.btwAftrekbaar}
                    size={3}
                    onChange={onChange}
                    validationMessage={validationMessages.btwAftrekbaar}
                    validationMessageType={validationMessageType}
                    disabled={disabled}
                    horizontal
                />
                <NumberInput
                    name={"bedragInclusiefBTW"}
                    label={"Bedrag incl BTW"}
                    labelInside
                    value={model.bedragInclusiefBTW}
                    isValuta
                    size={3}
                    readOnly
                    onChange={onChange}
                    validationMessage={validationMessages.bedragInclusiefBTW}
                    validationMessageType={validationMessageType}
                    disabled={disabled}
                />
            </Row>
            <Row>
                <RadioButtonGroup
                    name="subsidiesToegekend"
                    label={"Reeds Subsidies toegekend ?"}
                    labelInside
                    items={aftrekbaar}
                    value={model.subsidiesToegekend}
                    size={3}
                    onChange={onChange}
                    validationMessage={validationMessages.subsidiesToegekend}
                    validationMessageType={validationMessageType}
                    disabled={disabled}
                    horizontal
                    tooltip="Werden er reeds subsidies toegekend voor deze investering?"
                />
                {model.subsidiesToegekend && (model.subsidiesToegekend == "true" || model.subsidiesToegekend === true) ?
                    <NumberInput
                        name="verkregenSubsidieZelfdeWerken"
                        label={"Reeds toegekende subsidies"}
                        labelInside
                        value={model.verkregenSubsidieZelfdeWerken}
                        isValuta
                        size={3}
                        onChange={onChange}
                        disabled={disabled}
                        validationMessage={validationMessages.verkregenSubsidieZelfdeWerken}
                        validationMessageType={validationMessageType}
                    />
                    :
                    null}
                <NumberInput
                    name="totaalSubsidieerbaarBedrag"
                    label={"Totaal subsidieerbaar"}
                    labelInside
                    value={model.totaalSubsidieerbaarBedrag ? model.totaalSubsidieerbaarBedrag.toFixed(2) : 0.00}
                    isValuta
                    size={6}
                    readOnly
                    onChange={onChange}
                    tooltip={"Dit bedrag kan mogelijk in aanmerking komen voor subsidiëring"}
                    disabled={disabled}
                />
            </Row>
        </Form>
    </Section>);
};

InvesteringEditForm.defaultProps = {
    validationMessages: {}
};

InvesteringEditForm.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    model: PropTypes.object,
    validationMessages: PropTypes.object,
    onBewaarClick: PropTypes.func.isRequired,
    onSluitClick: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    investeringTypes: PropTypes.array.isRequired,
    hoofdCategorieen: PropTypes.array.isRequired,
    btwPercentages: PropTypes.array.isRequired,
    aftrekbaar: PropTypes.array.isRequired,
    validationMessageType: PropTypes.string
};

export default InvesteringEditForm;